"use strict";
// IMPORTANT: changes in this file will require a DB migration!
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_ERRORS_PER_ENTRY = void 0;
exports.MAX_ERRORS_PER_ENTRY = 500;
//# sourceMappingURL=common.js.map